import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { dataTable } from 'client/helpers/dataTables';

import SrPartnerSection from 'client/components/SrPartnerSection';
import SrDataTablePartnerTentantScreeningArchivedListings, {
  getDataTableSettingsFromProps,
} from 'client/components/SrDataTablePartnerTentantScreeningArchivedListings';
import { LISTING_SERVICE_TYPE_TENANT_SCREENING } from 'common/listingConstants';

@dataTable(getDataTableSettingsFromProps)
class SrDataTablePartnerTenantScreeningArchivedListingsSection extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    sinceDate: PropTypes.string,
    apartment: PropTypes.object,
    apartmentBuildingId: PropTypes.array,
    items: PropTypes.array.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
  };

  render() {
    const {
      partner,
      sinceDate,
      apartment,
      apartmentBuildingId,
      dataTableApiState,
      dataTableIsFullyLoaded,
      items,
    } = this.props;

    if (!dataTableApiState.inProgress && dataTableIsFullyLoaded && !items.length) {
      return null;
    }

    return (
      <>
        <SrPartnerSection title="Archived SunScreen Listings">
          <SrDataTablePartnerTentantScreeningArchivedListings
            partner={partner}
            sinceDate={sinceDate}
            apartment={apartment}
            apartmentBuildingId={apartmentBuildingId}
            serviceType={LISTING_SERVICE_TYPE_TENANT_SCREENING}
          />
        </SrPartnerSection>
      </>
    );
  }
}

SrDataTablePartnerTenantScreeningArchivedListingsSection.displayName =
  'SrDataTablePartnerTenantScreeningArchivedListingsSection'; // eslint-disable-line max-len

export default SrDataTablePartnerTenantScreeningArchivedListingsSection;
